import Handlebars from "handlebars"
import VideosTemplate from "../../handlebars/templates/videos/index.hbs"

class @App.Components.VideoGrid
  constructor: ->
    @container = $('.video-grid')
    @no_results = $('.js-no-search-results')

    $(document).on 'App::Components::VideoSearch::search_submit', (e) =>
      @container.empty().show()

    $(document).on 'App::Components::VideoSearch::success', (e) =>
      if e.videos.length > 0
        @load(e.videos, e.search_query, e.page, e.page_count)
        $('#search-text').hide()
        $('#results-text').show()
      else
        @no_results.show()

    $(document).on 'App::Components::VideoSearch::before_send', (e) =>
      @no_results.hide()

  load: (videos, search_query, page, page_count) =>
    if videos.length > 0
      for video, index in videos
        if video.youtube_id == videos[videos.length-1].youtube_id
          video.next_video = videos[0].youtube_id
        else
          video.next_video = videos[index+1].youtube_id
        if video.youtube_id == videos[0].youtube_id
          video.prev_video = videos[videos.length-1].youtube_id
        else
          video.prev_video = videos[index-1].youtube_id

      content = VideosTemplate(
        videos: videos
        q: search_query
        pagination: { page: page, pageCount: page_count }
        pages: (page_count > 1)
      )

      @container.html(content)

      # Re-init timeago
      $(".timeago").timeago()

  show: =>
    @container.show()
    $(document).trigger 'App::Components::VideoGrid::show'

  hide: =>
    @container.hide()
    $(document).trigger 'App::Components::VideoGrid::hide'

  isEmpty: =>
    @container.is(':empty')
